export const CARD_SURFACE =
  'rounded-xl bg-card shadow-card contrast:border contrast:border-border';

export const DETAILS_CARD = `${CARD_SURFACE} p-4`;
